import { SET_AUTHOR } from "./types";

export const setAuthor = (authorInfo) => ({ 
  type: SET_AUTHOR,
  payload: authorInfo,
})